import React from "react";
import __pages_import_0__ from "/src/pages/index.tsx";

const routes = [{"caseSensitive":false,"path":"/","element":React.createElement(__pages_import_0__)}];

export default routes;